import { Box, Chip, Typography } from '@mui/material'

class ApprovalManagerClass {
    getStatusChip = (status: string) => {
        switch (status) {
            case 'approved':
                return <Chip label='Approved' color='success' size='small' />
            case 'draft':
                return <Chip label='Draft' color='default' size='small' />
            case 'ready-for-review':
                return <Chip label='Ready for review' color='primary' size='small' />
            case 'ready-for-archival':
                return <Chip label='Ready for archival' color='warning' size='small' />
            case 'rejected':
                return <Chip label='Rejected' color='error' size='small' />
            default:
                return <Chip label={status} color='default' size='small' />
        }
    }

    statusField = (status: string) => {
        return (
            <Box>
                <Typography variant='subtitle2' color='text.secondary'>
                    Approval Status
                </Typography>
                <Box mt={0.5}>
                    {this.getStatusChip(status)}
                </Box>
            </Box>
        )
    }

    infoField = (label: string, value: React.ReactNode) => {
        return (
            <Box>
                <Typography variant='subtitle2' color='text.secondary'>
                    {label}
                </Typography>
                <Typography variant='body1' sx={{ mt: 0.5 }}>
                    {value}
                </Typography>
            </Box>
        )
    }
}
const ApprovalManager = new ApprovalManagerClass()
export default ApprovalManager
